module.exports = __webpack_public_path__ + "static/img/bod_slate_wide.e565047.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bod_slate_wide.jpg
// module id = 276
// module chunks = 1